import * as React from 'react';
import { useTranslation } from 'react-i18next';
import Immutable from 'immutable';

import {
  ButtonWrapper,
} from '../../../../components';

import './style.scss';

const GarbageCompanyResult = ({ entity }) => {
  const { t } = useTranslation();
  const address = entity.getIn(['field_company_address', 0, 'value']);
  const recognitions = entity.getIn(['field_recognitions'], Immutable.List());
  const websiteLink = entity.getIn(['field_website', 0, 'uri']);

  return (
    <article
      className="GarbageCompanyResult">
      <h2 className="GarbageCompanyResult-title">{entity.getIn(['title', 0, 'value'])}</h2>
      {address && <div className="GarbageCompanyResult-address">{`${address}`}</div>}
      {recognitions.size > 0 && <Recognitions {...{ recognitions }} />}
      {websiteLink &&
        <ButtonWrapper
          classNames="GarbageCompanyResult-button desktop"
          type="secondary"
          href={websiteLink}
        >
          {t('filters.garbage_companies.items.visit_website')}
        </ButtonWrapper>}

      {websiteLink && (
        <a
          className="GarbageCompanyResult-button mobile"
          aria-label={t('filters.garbage_companies.items.visit_website')}
          href={websiteLink}
        >
          <i className="icon-before icon-arrow" />
        </a>
      )}
    </article>
  );
};

const Recognitions = ({ recognitions }) => {
  const { t } = useTranslation();

  return (
    <div className="GarbageCompanyResult-recognitions">
      <span className="GarbageCompanyResult-subtitle">{t('filters.garbage_companies.recognizes.label')}</span>
      <div className="GarbageCompanyResult-inner">
        {recognitions?.map((recognition, index) => {
          const name = recognition.getIn(['entity', 'name', 0, 'value']);
          return <div key={`${name}-${index}`}><i className="icon-before icon-checkmark" />{name}</div>;
        })}
      </div>
    </div>
  );
};

export default GarbageCompanyResult;
